<template>
  <div>
    <v-dialog v-model="dialog.dialogProgress" persistent width="300">
      <v-card color="primary" outlined>
        <v-card-text>
          {{progressMessage}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-card outlined>
      <v-toolbar flat dense dark color="primary">
        <v-toolbar-title>Customer Browse</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="
          var valueSend = [];
          sendToParentComponent(valueSend)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-data-table
          v-model="vDataTable.selected"
          :headers="headers"
          :items="vDataTable.data"
          :search="vDataTable.search"
          show-select
          :single-select="receiveVar.singleSelect"
          fixed-header
          height="400"
          :page.sync="vDataTable.options.page"
          :itemsPerPage.sync="vDataTable.options.itemsPerPage"
          :options.sync="vDataTable.options"
          :footer-props="{
            itemsPerPageText: $t('itemsPerPageText'),
            itemsPerPageAllText: $t('itemsPerPageAllText'),
            showFirstLastPage: true,
            showCurrentPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-minus',
            nextIcon: 'mdi-plus',
          }"
          item-key="proj_cd"
          class="elevation-1">
          <template v-slot:header.data-table-select="{ on, props }">
            <tr>
              <td>
                <v-simple-checkbox :ripple="false" v-bind="props" v-on="on"></v-simple-checkbox>
              </td>
              <td v-if="vDataTable.selected.length > 0">
                {{vDataTable.selected.length}}
              </td>
            </tr>
          </template>
          <template v-slot:top>
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-text-field v-model="vDataTable.search" append-icon="mdi-magnify" :label="$t('search')"></v-text-field>
            </v-toolbar>
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:item.data-table-select="{ isSelected, select }">
            <v-simple-checkbox :value="isSelected" :ripple="false" @input="select($event)" ></v-simple-checkbox>
          </template>
          <template v-slot:no-data>
            <v-alert type="info">
              {{$t('noData')}}
            </v-alert>
          </template>
          <template v-slot:no-results>
            <v-alert type="warning">
              {{stringFormat($t('searchNotFound'),vDataTable.search)}}
            </v-alert>
          </template>
          <template v-slot:footer>
            <tr class="sticky-table-footer" style="position: absolute">
              <td>Selected({{vDataTable.selected.length}})s</td> 
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outlined color="primary" class="mb-2" style="text-transform: capitalize"
          @click="
            var valueSend = [];
            valueSend.actionReturn = 'OK'
            valueSend.dataSelected = vDataTable.selected
            sendToParentComponent(valueSend)">
        {{$t('ok')}}
        </v-btn>
        <v-divider class="mx-1" inset vertical></v-divider>
        <v-btn outlined color="primary" class="mb-2" style="text-transform: capitalize"
          @click="
            var valueSend = [];
            sendToParentComponent(valueSend)">
        {{$t('cancel')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
  export default {
    props: ['receiveVar'],
    data () {
      return {
        utils: require('@/utils'),
        stringFormat: require('string-format'),
        dialog: {
          dialogProgress: false,
        },
        progressMessage: '',
        vDataTable: {
          search: '',
          selected: [],
          data: [],
          editedIndex: -1,
          editedItem: {
            win_name: '',
            window_comment: ''
          },
          defaultItem: {
            win_name: '',
            window_comment: ''
          },
          options: {
            page: 1,
            itemsPerPage: -1,
            sortBy: [],
            sortDesc: [],
            groupBy: [],
            groupDesc: true,
            multiSort: true,
            // mustSort: true
          },
        },
      }
    },
    created: function () {
    },
    computed: {
      headers () {
        return [
          { text: 'Project Code', value: 'proj_cd', align: 'left' },
          { text: 'Description', value: 'proj_desc', align: 'left' },
          { text: 'Remark', value: 'remark', align: 'left' },
        ]
      }
    },
    methods: {
      sendToParentComponent (value) {
        this.selected = []
        value.browseName = this.receiveVar.browseName
        value.childSend = this.$options._componentTag
        this.$emit('eventReturn', value)
      },
      async retrieveProject () {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        await this.axios.post(process.env.VUE_APP_API + '/browse/retrieveProject' + process.env.VUE_APP_DATABASE_TYPE)
          .then(response => {
            if (response.data.isSuccess) {
              this.vDataTable.data = response.data.data
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(async e => {
            await this.$swal({type: 'error', title: e.message})
          })
        this.dialog.dialogProgress = false
      },
    }
  }
</script>